import { MarkNode } from '@lexical/mark';
import {
  LexicalEditor,
  ParagraphNode,
  SerializedEditorState,
  SerializedParagraphNode,
  SerializedTextNode,
  TextNode,
  createEditor,
} from 'lexical';
import { CustomParagraphNode } from '../nodes/CustomParagraphNode';
import { mainTheme } from '../Theme/mainTheme';

export const lexicalCTAEditorConfig = {
  namespace: 'call-to-action-editor',
  editable: false,
  theme: mainTheme,
  onError: (error): void => {
    throw error;
  },
  nodes: [
    TextNode,
    ParagraphNode,
    // while fixing DCC-11480, found a custom-paragraph node in CTA lexicalState - needs further investigation on how it got there
    CustomParagraphNode,
    MarkNode,
  ],
};

export function createLexicalCTAEditor(lexicalStateRaw: string | null | undefined): LexicalEditor {
  const editor = createEditor(lexicalCTAEditorConfig);

  if (lexicalStateRaw) {
    editor.setEditorState(editor.parseEditorState(lexicalStateRaw));
  }

  return editor;
}

export function createLexicalCTAEditorEmptyState(text?: string): string {
  const children: SerializedTextNode[] = [];
  if (text) {
    children.push({
      detail: 0,
      format: 0,
      mode: 'normal',
      style: '',
      text,
      type: 'text',
      version: 1,
    });
  }

  const state: SerializedEditorState<SerializedParagraphNode> = {
    root: {
      children: [{
        children,
        direction: null,
        format: '',
        indent: 0,
        type: 'paragraph',
        version: 1,
        textFormat: 0,
        textStyle: '',
      }],
      direction: 'ltr',
      indent: 0,
      type: 'root',
      format: '',
      version: 1,
    },
  };

  return JSON.stringify(state);
}
